import React from 'react';

import i18next from 'i18next';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { CronJobName } from '../CronJobsCRUDForm.types';

import Select from 'components/shared/Select';

import { AutoSendToFlexBlockSection } from './AutoSendToFlexBlockSection';
import { SyncEmployeeRoutesSection } from './SyncEmployeeRoutesSection';

const jobNamesOptions: { value: CronJobName; label: string }[] = [
  {
    value: 'export-employee-hours',
    label: i18next.t('cronJobs.jobs.cronJobs.form.export-employee-hours')
  },
  {
    value: 'auto-send-to-flex',
    label: i18next.t('cronJobs.jobs.auto-send-to-flex')
  },
  {
    value: 'sync-employee-routes',
    label: i18next.t('cronJobs.jobs.sync-employee-routes')
  }
];

interface Props {
  selectedJobType: CronJobName;
  changeJobType: React.Dispatch<React.SetStateAction<CronJobName>>;
}

export const SynchronisationCronJobsFormContent: React.FC<Props> = ({
  selectedJobType,
  changeJobType
}) => {
  const { t } = useTranslation();
  const { setValue, reset } = useFormContext();

  return (
    <>
      <Select
        variant="outlined"
        valueProp={selectedJobType}
        label={t('cronJobs.grid.jobName')}
        options={jobNamesOptions}
        onSelected={(value) => {
          changeJobType(value);
          setValue('jobName', value);
          reset();
        }}
      />
      {selectedJobType === 'auto-send-to-flex' ? (
        <AutoSendToFlexBlockSection />
      ) : selectedJobType === 'sync-employee-routes' ? (
        <SyncEmployeeRoutesSection />
      ) : (
        <></>
      )}
    </>
  );
};
